$(document).ready(function () {
  $(".addToCart").on("click", function (e) {
    e.preventDefault(),
      // $(this).animate({opacity: '0.5'},1000).text('Adding');
      //   console.log(data);
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: $(this).parent().parent().serialize(),
        dataType: "json",
        success: function (data) {
          get_cart_details();
          //   $('.addToCart').animate({opacity: '1'}).text('Add To Cart');
          $(".index").addClass("cartShow");
        },
        error: function (err) {
          console.log("error");
        },
      });
  });

  $(".product__btn").on("click", function (e) {
    e.preventDefault(), $(this).addClass("loading");
    let upsellID = $(this).data("slide");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $(this).parent().serialize(),
      dataType: "json",
      success: function (data) {
        // if (upsellID != "") {
        //   let slideIndex = $("#" + upsellID).data("slick-index");
        //   $("#" + upsellID).fadeOut();
        //   setTimeout(function () {
        //     $(".upsell-cart-slider").slick("slickRemove", slideIndex - 1);
        //     $(".upsell-cart-slider").slick("setPosition");
        //   }, 500);
        // }
        get_cart_details();
        $("body").addClass("cartShow");
      },
      error: function (err) {
        console.log("error");
      },
    });
  });

  $(".single-product__atc").on("click", function (e) {
    e.preventDefault(), $(this).addClass("loading");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $(this).parent().parent().serialize(),
      dataType: "json",
      success: function (data) {
        get_cart_details();
        $("body").addClass("cartShow");
      },
      error: function (err) {
        console.log("error");
      },
    });
  });

  // cart details
  function setCartHeight() {
    const cartList = $(".cart-item-wrap");
    let windowHeight = $(window).height(),
      cartTopHeight = $(".cart-top").outerHeight(),
      cartCheckoutHeight = $(".cart-checkout").outerHeight();
    let upsellHeight = 0;
    if ($(".upsell-item").length > 0) {
      upsellHeight = $(".upsell-cart-wrap").outerHeight();
    } else {
      $(".upsell-cart-wrap").hide();
    }

    let setHeight =
      windowHeight - cartTopHeight - cartCheckoutHeight - upsellHeight;
    cartList.css("max-height", setHeight + "px");
  }
  setTimeout(function () {
    setCartHeight();
  }, 500);
  $(window).on("resize", setCartHeight());

  function get_cart_details() {
    $.getJSON("/cart.js", function (cart) {
      setCartHeight();
      var drawer_item_html = "";
      var cart_items = cart.items;
      // var currency = cart.currency;
      var total_items = cart.item_count;
      var total_price = cart.total_price;
      $(".total-cost").text(
        my_Shop_Currency + " " + (total_price * 0.01).toFixed(2)
      );
      $(".cart-trigger dfn").text(total_items);

      var shipping_required =
        free_shipping_goal - (total_price * 0.01).toFixed(2);
      console.log("test" + shipping_required);
      var shipping_progress = (total_price * 0.01 * 100) / free_shipping_goal;

      $(".cart-progress-bar span").css("width", shipping_progress + "%");
      if (shipping_required >= 1) {
        $(".cart-progress p").html(
          'SPEND ANOTHER <em class="shipping_purchase-more">' +
            my_Shop_Currency +
            shipping_required +
            "</em> TO QUALIFY FOR FREE SHIPPING"
        );
      } else {
        $(".cart-progress p").html(free_shipping_message);
      }

      for (var i = 0; i <= cart_items.length; i++) {
        var product_img = cart_items[i].image;
        var product_name = cart_items[i].product_title;
        var product_id = cart_items[i].id;
        var product_product_id = cart_items[i].product_id;
        var product_name_handlize = product_name
          .replace(/ /g, "-")
          .toLowerCase();
        var product_variant_option_name =
          cart_items[i].options_with_values[0].name;
        var product_variant_option_value =
          cart_items[i].options_with_values[0].value;
        var product_variant = cart_items[i].variant_title;
        var product_qty = cart_items[i].quantity;
        var product_price = cart_items[i].price;
        var product_variant_id = cart_items[i].variant_id;
        var product_url = cart_items[i].url;
        var product_key = cart_items[i].key;
        var new_product_total_price = cart_items[i].final_line_price;
        // console.log('added item');
        drawer_item_html += '<div class="cart-item">';
        drawer_item_html +=
          '<a href="' +
          product_url +
          '" class="cart-item-thumb bg-white-linen">';
        drawer_item_html += "<figure>";
        drawer_item_html +=
          '<img src="' + product_img + '" alt="' + product_name + '">';
        drawer_item_html += "</figure>";
        drawer_item_html += "</a>";
        drawer_item_html += '<div class="cart-item-content">';
        drawer_item_html += '<div class="cart-item-content-top">';
        drawer_item_html += '<a class="cart-item-content-top-left">';
        drawer_item_html += "<h6>" + product_name + "</h6>";
        if (product_variant_option_value != "Default Title") {
          drawer_item_html +=
            "<span>" +
            product_variant_option_name +
            ": <dfn>" +
            product_variant_option_value +
            "</dfn></span>";
        }

        drawer_item_html += "</a>";
        drawer_item_html += '<div class="cart-item-content-top-right">';
        drawer_item_html +=
          '<h6 class="item-price" data-id="' +
          product_variant_id +
          '">' +
          my_Shop_Currency +
          "" +
          (new_product_total_price * 0.01).toFixed(2) +
          "</h6>";
        drawer_item_html += "</div>";
        drawer_item_html += "</div>";
        drawer_item_html +=
          '<div class="cart-item-content-bottom flex-box flex-vertical-align">';
        drawer_item_html += '<div class="input-group">';
        drawer_item_html +=
          '<button class="minus-item" onclick="decreaseItem(event,this)" data-id="' +
          product_variant_id +
          '">–</button>';
        drawer_item_html +=
          '<input type="number" class="item-count" name="' +
          product_variant_id +
          '" data-id="' +
          product_variant_id +
          '" value="' +
          product_qty +
          '">';
        drawer_item_html +=
          '<button class="plus-item"  onclick="increaseItem(event, this)" data-id="' +
          product_variant_id +
          '">+</button>';
        drawer_item_html += "</div>";
        drawer_item_html +=
          '<a href="#" class="cart-item-remove" onclick="itemRemove(event, this)" data-id="' +
          product_variant_id +
          '">Remove</a>';
        drawer_item_html += "</div>";
        drawer_item_html += "</div>";
        drawer_item_html += "</div>";

        $(".cart-item-wrap").html(drawer_item_html);
        $(".product__btn").removeClass("loading");
        $(".single-product__atc").removeClass("loading");

        if ($("#upsell-product-" + product_product_id).length > 0) {
          let slideIndex = $("#upsell-product-" + product_product_id).data(
            "slick-index"
          );
          $("#upsell-product-" + product_product_id).fadeOut();
          setTimeout(function () {
            $(".upsell-cart-slider").slick("slickRemove", slideIndex - 1);
            $(".upsell-cart-slider").slick("setPosition");
          }, 500);
        }
      }
    });
  }
});
